import { FC, ReactNode, createContext, useContext } from 'react';
import config from '../config/config';

interface IOrganizationState {
	readonly organizationSlug: string;
}

const defaultOrganizationState: IOrganizationState = { organizationSlug: config.organization.fallback };

const OrganizationDomain = createContext(defaultOrganizationState);

export const useOrganizationDomainContext = (): IOrganizationState => useContext(OrganizationDomain);

export const getOrganizationDomain = (): string => {
	const { hostname } = window.location;

	const match = hostname.match(config.organization.domainRegex);

	if (match && match.groups?.slug) {
		return match.groups.slug;
	}

	return defaultOrganizationState.organizationSlug;
};

export const OrganizationProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const organizationSlug = getOrganizationDomain();

	return <OrganizationDomain.Provider value={{ organizationSlug }}>{children}</OrganizationDomain.Provider>;
};
